// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__s+u9O","app-icon":"Footer_app-icon__Jek6I","footer-links":"Footer_footer-links__hb2ei","footer-icon":"Footer_footer-icon__6nveW"};